// Utility function to filter out special topics that shouldn't be displayed to users
export const filterDisplayableTopics = (topics: any[]) => {
  return topics.filter(
    (topic) =>
      !topic.name.startsWith('Special:') &&
      !topic.name.startsWith('Context:') &&
      !topic.name.startsWith('Admin:')
  );
};

// For grouped topics (categories with topics array)
export const filterDisplayableGroupedTopics = (groupedTopics: any[]) => {
  return groupedTopics
    .map((category) => ({
      ...category,
      topics: filterDisplayableTopics(category.topics),
    }))
    .filter((category) => category.topics.length > 0); // Remove empty categories
};

export const shouldFilterTopic = (topicName: string) => {
  return (
    topicName.startsWith('Special:') ||
    topicName.startsWith('Context:') ||
    topicName.startsWith('Admin:')
  );
};
